import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'

import styles from './teacher-notes.styles.js'

import TeacherNotesModal from '../teacher-notes-modal/teacher-notes-modal.container.js'

import Button from 'pobble-components/dist/button'

class TeacherNotes extends Component {
  constructor(props) {
    super(props)
    this.state = { openModal: false }
  }

  openModalHandler = () => {
    this.setState({ openModal: true })
  }

  closeModalHandler = () => {
    this.setState({ openModal: false })
  }

  render() {
    const { classes, id, notes, onUpdate } = this.props
    return (
      <Fragment>
        <Button
          simple
          className={classes.container}
          action={this.openModalHandler}>
          {notes || 'n/a'}
        </Button>
        <TeacherNotesModal
          isOpen={this.state.openModal}
          id={id}
          notes={notes}
          onUpdate={onUpdate}
          onClose={this.closeModalHandler}
        />
      </Fragment>
    )
  }
}

export default injectSheet(styles)(TeacherNotes)
